/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * A means of paying a competition's entry cost. FUEL debits the player's balance; TOKEN burns one accepted virtual token, and the competition's own entry fee is deposited into the prize pool on the player's behalf. The token carries no value of its own.
 * @export
 */
export const EntryTender = {
    FUEL: 'FUEL',
    TOKEN: 'TOKEN'
} as const;
export type EntryTender = typeof EntryTender[keyof typeof EntryTender];


export function instanceOfEntryTender(value: any): boolean {
    for (const key in EntryTender) {
        if (Object.prototype.hasOwnProperty.call(EntryTender, key)) {
            if (EntryTender[key as keyof typeof EntryTender] === value) {
                return true;
            }
        }
    }
    return false;
}

export function EntryTenderFromJSON(json: any): EntryTender {
    return EntryTenderFromJSONTyped(json, false);
}

export function EntryTenderFromJSONTyped(json: any, ignoreDiscriminator: boolean): EntryTender {
    return json as EntryTender;
}

export function EntryTenderToJSON(value?: EntryTender | null): any {
    return value as any;
}

export function EntryTenderToJSONTyped(value: any, ignoreDiscriminator: boolean): EntryTender {
    return value as EntryTender;
}

